import { render, staticRenderFns } from "./copyController.vue?vue&type=template&id=051c8566&"
import script from "./copyController.vue?vue&type=script&lang=ts&"
export * from "./copyController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports